import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Contract API - Base definition
 *
 * This is the base API slice for the Contract service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see contractEndpoints.ts - Contract CRUD operations
 * @see feeScheduleEndpoints.ts - Fee Schedule management
 * @see drgEndpoints.ts - DRG management and upload/download
 * @see cptEndpoints.ts - CPT management and upload/download
 * @see carveOutEndpoints.ts - CarveOut management and upload/download
 * @see ruleEndpoints.ts - Rule management
 * @see dimensionEndpoints.ts - Dimension lookups (Financial Classes, Calc Types, etc.)
 */
export const contractApi = createApi({
  reducerPath: 'contractApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.contracts),
  tagTypes: [
    // Contract tags
    'Contract',
    'ContractList',
    // Fee Schedule tags
    'FeeSchedule',
    'FeeScheduleList',
    // DRG tags
    'Drg',
    'DrgList',
    // CPT tags
    'Cpt',
    'CptList',
    // CarveOut tags
    'CarveOut',
    'CarveOutList',
    // Rule tags
    'Rule',
    'RuleList',
    // Grouper tags
    'Grouper',
    // Dimension tags
    'FinancialClass',
    'CalcType',
    'FacilityType',
    'MedicareContracts',
  ],
  endpoints: () => ({}),
});
